import {RootState} from '@/reducers/store';
import {useEffect,useState} from 'react';
import {useSelector} from 'react-redux';
import useUrlType from './useUrlType';

const useResponseId = () => {
    // Set initial state with window.innerWidth
    const {isPatient} = useUrlType();
    const [answerResponseId, setAnswerResponseId] = useState<number>()
    const {  patient} = useSelector((state:RootState) => state.patientSurvey);
    const {  responseId } = useSelector((state:RootState) => state.poaSurvey);

    useEffect(() => {
        if(isPatient)
    {
        if(patient){
            setAnswerResponseId(patient.questionnaireResponseId)
        }
    
    }else {
        if(responseId){
            setAnswerResponseId(responseId)
        }
       
    }    
    }, [patient, responseId, isPatient])

    const getResponseId = ()=>{
        return answerResponseId
    }

    return {answerResponseId, getResponseId}
}

export default useResponseId
